import { Component, Input } from '@angular/core';

export interface TableLegendItem{
  legendLabel: string;
  legendColor?: string;
  legendIcon?: string;
  legendIconSize?: string;
  iconFilled?: boolean;
}

@Component({
  selector: 'app-table-legend',
  templateUrl: './table-legend.component.html',
  styleUrls: ['./table-legend.component.scss'],
})
export class TableLegendComponent {
  @Input() items: TableLegendItem[] = [];
  
}
